"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadTags = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const page_frame_next_utils_1 = require("@zillow/page-frame-next-utils");
const PageFrameContext_1 = require("./PageFrameContext");
const HeadTags = ({ Container }) => (react_1.default.createElement(PageFrameContext_1.PageFrameContext.Consumer, null, ({ headTags, preloadTags }) => {
    const tags = {
        ...((preloadTags === null || preloadTags === void 0 ? void 0 : preloadTags.json) || {}),
        ...((headTags === null || headTags === void 0 ? void 0 : headTags.json) || {}),
    };
    if (Object.keys(tags).length) {
        // we have our own client profiler init component
        delete tags['scripts.clientProfiler'];
        return react_1.default.createElement(Container, null, (0, page_frame_next_utils_1.parseHtmlTags)(tags));
    }
    return null;
}));
exports.HeadTags = HeadTags;
exports.HeadTags.propTypes = {
    Container: prop_types_1.default.elementType,
};
exports.HeadTags.defaultProps = {
    Container: ({ children }) => react_1.default.createElement(react_1.Fragment, { key: "head-tags" }, children),
};
